import controller from './campaignsPlaceHolder.controller';
import template from './campaignsPlaceHolder.html';
import './campaignsPlaceHolder.scss';
/**
 * @ngdoc component
 * @name CampaignsPlaceHolder
 * @description
 * The menu bar component of the app.
 *
 * @memberof home
 */
export default {
  /**
   * The controller class for the component.
   * @type {CampaignsPlaceHolderController}
   */
  controller,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings
   * @type {Object}
   * @property {Integer} numberOfItems the number of items to show.
   */
  bindings: {
    numberOfItems: '<',
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/home/components/campaignsPlaceHolder/campaignsPlaceHolder.component.js